<template>
    <div id="app" class="app fond">
         <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section>
                        <div class="Fiche">
                            <div class="Infos Contact">
                                <p class="paragraphe" v-html="listeHorairesNS[0].acf.description"></p>
                                
                                <h4 style="text-align: center">{{date}}</h4>
                                <div class="encadre carte" style="margin: 0 auto">
                                    <div>
                                        <img src="static/css/img/Pages/Accueil/Nuisances_sonores.jpg" alt="Nuisance sonore (tondeuse)">
                                    </div>      
                                    <div class="encadre carte">
                                        <div>
                                            <img src="static/css/img/Pages/Accueil/Nuisances_sonores.jpg" alt="Nuisance sonore (tondeuse)">
                                        </div>
                                        <section class="contenu-carte">
                                            <h5>Horaires d'utilisation d'appareils avec nuisance sonore</h5>
                                            <table class="TableHoraire">
                                                <tbody>
                                                    <div v-for="jour in listeHorairesNS[0].acf.horaires.body.slice(0,5)" :key="jour.id">
                                                        <div v-if="jour[0].c == joursemaine && Ferie == false"><tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id"><div v-if="colonne.c != ''">{{colonne.c}}</div></tr></div>
                                                    </div>
                                                    <div v-for="jour in listeHorairesNS[0].acf.horaires.body.slice(5, 6)" :key="jour.id">
                                                        <div v-if="joursemaine == 'Samedi' && Ferie == false"><tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id"><div v-if="colonne.c != ''">{{colonne.c}}</div></tr></div>
                                                    </div>
                                                    <div v-for="jour in listeHorairesNS[0].acf.horaires.body.slice(6, 7)" :key="jour.id">
                                                        <div v-if="joursemaine == 'Dimanche' || Ferie == true"><tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id"><div v-if="colonne.c != ''">{{colonne.c}}</div></tr></div>
                                                    </div>
                                                </tbody>
                                            </table>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div class="contenu-droit-page" v-if="listeHorairesNS[0].acf.image != ''">
                                <iframe :src="listeHorairesNS[0].acf.lien" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Nuisance-Sonore',
    data () {
        return{
            listeHorairesNS:{
                id: 0,
                acf:{
                    horaires:{
                        body:{
                            c:null
                        }
                    },
                    lien: null,
                    description: null
                }
            },
            date: null,
            time: null,
            joursemaine: null,
            datejour: null,
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
       var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.dateJourCompa = annee+'-'+moisnumerique[moi]+'-'+j
        this.dateJourCompaChiffre = annee+moisnumerique[moi]+j
        this.jourInfini = mois[moi];


        axios.get(param.hostacf+'nuisance_sonore')
        .then(response =>{
            this.listeHorairesNS = response.data;
        })
        .catch(error => console.log(error))


        axios.get('https://calendrier.api.gouv.fr/jours-feries/metropole/'+annee+'.json')
        .then(response =>{
            this.listeJourFerie = response.data;

            this.json = [];
            var i = 0;
            let jourferie = null;
            for(jourferie in this.listeJourFerie){
                let test = jourferie.split('-');
                let dateJourCompaSplit = this.dateJourCompa.split('-');
                let dateJourCompaNum = dateJourCompaSplit[0]+dateJourCompaSplit[1]+dateJourCompaSplit[2]
                let dateferieCompa = test[0]+test[1]+test[2];
                let datefr = test[2]+'/'+test[1]+'/'+test[0];
                if(dateferieCompa == dateJourCompaNum){
                    this.Ferie = true;
                }else{
                    this.Ferie = false
                }

                console.log(this.Ferie)

                
                this.json[i] = datefr;

                if(this.Ferie == true){
                    return this.Ferie
                }

                i++;
            }
        })
        .catch(error => console.log(error))

        

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == "Horaires d'utilisation d'appareils à nuisance sonore"){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))

    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Nuisance-Sonore.vue